import React from 'react';
import { useSelector } from 'react-redux';
import { useFooter } from './useFooter';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { MarginProps } from '../../../../theme/styledProps';
import { StickyFooter } from '../../../../CommonComponents/OPL/StickyFooter/StickyFooter';
import { externalHostSelector as selectExternalHostSelector } from '../../../../ConsumerArea/ConsumerAreaSelector';
import { EXTERNAL_HOST } from '../../../../ConsumerArea/ConsumerAreaConstants';

export const Footer = (props: MarginProps) => {
  const externalHost = useSelector(selectExternalHostSelector);

  if (externalHost === EXTERNAL_HOST.ELEMENT) {
    return null;
  }
  return <FooterContent {...props} />;
};

export const FooterContent = (props: MarginProps) => {
  const { data, actions } = useFooter();

  if (!data) {
    return null;
  }

  const { previousGoal, nextGoal } = data;
  const { navigateToGoal } = actions;

  if (!previousGoal && !nextGoal) {
    return null;
  }

  return (
    <StickyFooter {...props}>
      <Box>
        {previousGoal && (
          <Button
            variant="secondary"
            leftIcon="fas fa-arrow-left"
            onClick={() => navigateToGoal(previousGoal.GoalId, previousGoal.GoalType)}
            size="large"
          >
            {previousGoal.GoalName}
          </Button>
        )}
      </Box>

      <Box>
        {nextGoal && (
          <Button
            rightIcon="fas fa-arrow-right"
            onClick={() => navigateToGoal(nextGoal.GoalId, nextGoal.GoalType)}
            size="large"
          >
            {nextGoal.GoalName}
          </Button>
        )}
      </Box>
    </StickyFooter>
  );
};
